/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Set instead of hotel_details when booking_type is vehicle.
 * @export
 * @interface UserRewardLedgerEntryVehicleDetails
 */
export interface UserRewardLedgerEntryVehicleDetails {
    /**
     * Rental car company (e.g. National).
     * @type {string}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    vehicleClass?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    pickupLocation?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    pickupDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    dropoffLocation?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    dropoffDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    confirmationNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    totalCost?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    currency?: string | null;
    /**
     * User-facing Gondola booking confirmation number for the rental.
     * @type {string}
     * @memberof UserRewardLedgerEntryVehicleDetails
     */
    gondolaBookingId?: string | null;
}

/**
 * Check if a given object implements the UserRewardLedgerEntryVehicleDetails interface.
 */
export function instanceOfUserRewardLedgerEntryVehicleDetails(value: object): value is UserRewardLedgerEntryVehicleDetails {
    return true;
}

export function UserRewardLedgerEntryVehicleDetailsFromJSON(json: any): UserRewardLedgerEntryVehicleDetails {
    return UserRewardLedgerEntryVehicleDetailsFromJSONTyped(json, false);
}

export function UserRewardLedgerEntryVehicleDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRewardLedgerEntryVehicleDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'vendorName': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'vehicleClass': json['vehicle_class'] == null ? undefined : json['vehicle_class'],
        'pickupLocation': json['pickup_location'] == null ? undefined : json['pickup_location'],
        'pickupDatetime': json['pickup_datetime'] == null ? undefined : (new Date(json['pickup_datetime'])),
        'dropoffLocation': json['dropoff_location'] == null ? undefined : json['dropoff_location'],
        'dropoffDatetime': json['dropoff_datetime'] == null ? undefined : (new Date(json['dropoff_datetime'])),
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'totalCost': json['total_cost'] == null ? undefined : json['total_cost'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
    };
}

export function UserRewardLedgerEntryVehicleDetailsToJSON(json: any): UserRewardLedgerEntryVehicleDetails {
    return UserRewardLedgerEntryVehicleDetailsToJSONTyped(json, false);
}

export function UserRewardLedgerEntryVehicleDetailsToJSONTyped(value?: UserRewardLedgerEntryVehicleDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vendor_name': value['vendorName'],
        'vehicle_class': value['vehicleClass'],
        'pickup_location': value['pickupLocation'],
        'pickup_datetime': value['pickupDatetime'] == null ? value['pickupDatetime'] : value['pickupDatetime'].toISOString(),
        'dropoff_location': value['dropoffLocation'],
        'dropoff_datetime': value['dropoffDatetime'] == null ? value['dropoffDatetime'] : value['dropoffDatetime'].toISOString(),
        'confirmation_number': value['confirmationNumber'],
        'total_cost': value['totalCost'],
        'currency': value['currency'],
        'gondola_booking_id': value['gondolaBookingId'],
    };
}

